<div class="content">
  <div class="sidebar standard-listing">
    <div class="header title-and-buttons">
      <div class="title-bar">
        <span class="title">Compasses</span>
        <div class="buttons">
          <button #infoButton mat-button class="button info" title="Info" (click)="showInfoPopover()">
            <img src="assets/ic_information_blk.svg" class="icon" />
          </button>
          <!-- Could be a puzzle piece icon -->
          <button mat-button class="button piece" title="Templates" (click)="openPieceManager()">
            <img src="assets/content-icon/ic-21.svg" class="icon" />
          </button>
        </div>
      </div>
    </div>
    <input id="huddy-compass-filter-input" type="text" class="listing-filter" placeholder="Filter by name or provider"
      [(ngModel)]="filterText" />
    <div *ngIf="isLoading()" class="listings">
      <listing-component *ngFor="let listing of [1,2,3,4,5,6,7,8,9]" [skeleton]="true" aboveTitle="true"
        [extraDescs]="[null, null]"></listing-component>
    </div>
    <div *ngIf="!isLoading() && filteredListings.length == 0" class="empty-state">
      Nothing to show
    </div>
    <div *ngIf="!isLoading() && filteredListings.length > 0" class="listings">
      <listing-component *ngFor="let listing of filteredListings" [title]="listing.getName()" [desc]="listing.getDesc()"
        [extraDescs]="listing.getExtraDescs()" [aboveTitle]="listing.getProvider()?.name"
        [selected]="listingIsSelected(listing)" [isDirty]="listing.isDirty()" [hasError]="listing.hasVisibleIssue()"
        [disabled]="getSelected() && !getSelected().isEditing(null)"
        (click)="(getSelected() && !getSelected().isEditing(null)) ? null : selectListing(listing)"></listing-component>
    </div>
    <button mat-icon-button *ngIf="!isLoading()" class="circle-button" title="Add a new compass"
      (click)="addSavedCompass()">
      <img src="assets/content-icon/ic-04.svg" />
    </button>
  </div>
  <div class="body" *ngVar="getSelected() as selected" [ngClass]="{scrollable: !(isLoading() || selected)}">
    <div *ngIf="isLoading()" class="body-content skeleton">
      <div #scrollableContent class="scrollable-content">
        <div class="page-title-container"><span class="page-title skeleton-animation"></span></div>
        <div class="tabs">
          <button mat-button class="body-standard-tab selected" disabled>
            <span class="text">General Information</span>
          </button>
          <button mat-button class="body-standard-tab" disabled>
            <span class="text">Trackables</span>
          </button>
          <button mat-button class="body-standard-tab" disabled>
            <span class="text">Assessment</span>
          </button>
          <button mat-button class="body-standard-tab" disabled>
            <span class="text">Score Summary</span>
          </button>
          <button mat-button class="body-standard-tab" disabled>
            <span class="text">Documents</span>
          </button>
        </div>
        <div class="fields skeleton">
          <div class="input-area">
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button mat-button class="text-button secondary" disabled>Delete</button>
        <button mat-button class="text-button" disabled>Save</button>
      </div>
    </div>
    <div class="body-content" *ngIf="!(isLoading() || selected)">
      <div class="page-empty-state-area">
        <img src="assets/empty-state/journal_empty_filter.svg" class="empty-state-image">
        <span class="title">{{getEmptyStateTitle()}}</span>
        <span class="desc">{{getEmptyStateDesc()}}</span>
        <button mat-button class="add-button centered-button" (click)="addSavedCompass()">
          <img src="assets/content-icon/ic-04.svg" />
          <span class="text">Add</span>
        </button>
      </div>
    </div>
    <div *ngIf="!isLoading() && selected" class="body-content">
      <div #scrollableContent cdkScrollable class="scrollable-content">
        <div #sectionId class="section-id">{{selected.id}},{{selected.groupIndex}}</div>
        <div class="page-title-container"><span class="page-title">{{selected.getListingName()}}</span></div>
        <div class="tabs" *ngVar="!(selected.isEditing(null) || selected.isEditing()) as editingInner">
          <button mat-button *ngVar="selected.groups[0] as group" class="body-standard-tab"
            [ngClass]="{selected: selected.groupIndex == 0, dirty: group.isDirty(), error: group.hasVisibleIssue()}"
            [disabled]="editingInner" (click)="selected.groupIndex = 0"><span class="text">
              General Information
            </span>
            <div class="dot"></div>
          </button>
          <button mat-button *ngVar="selected.groups[1] as group" class="body-standard-tab"
            [ngClass]="{selected: selected.groupIndex == 1, dirty: group.isDirty(), error: group.hasVisibleIssue()}"
            [disabled]="editingInner || (selected.isNew() && selected.maxGroup != null && selected.maxGroup < 1)"
            (click)="selected.groupIndex = 1"><span class="text">
              Trackables
            </span>
            <div class="dot"></div>
          </button>
          <button mat-button *ngVar="selected.groups[2] as group" class="body-standard-tab"
            [ngClass]="{selected: selected.groupIndex == 2, dirty: group.isDirty(), error: group.hasVisibleIssue()}"
            [disabled]="editingInner || (selected.isNew() && selected.maxGroup != null && selected.maxGroup < 2)"
            (click)="selected.groupIndex = 2"><span class="text">
              Assessment
            </span>
            <div class="dot"></div>
          </button>
          <button mat-button *ngVar="selected.groups[3] as group" class="body-standard-tab"
            [ngClass]="{hidden: selected.usesCustomScoreClass(), selected: selected.groupIndex == 3, dirty: group.isDirty(), error: group.hasVisibleIssue()}"
            [disabled]="editingInner || (selected.isNew() && selected.maxGroup != null && selected.maxGroup < 3)"
            (click)="selected.groupIndex = 3"><span class="text">
              Score Summary
            </span>
            <div class="dot"></div>
          </button>
          <button mat-button *ngVar="selected.groups[4] as group" class="body-standard-tab"
            [ngClass]="{hidden: selected.usesCustomScoreClass(), selected: selected.groupIndex == 4, dirty: group.isDirty(), error: group.hasVisibleIssue()}"
            [disabled]="editingInner || (selected.isNew() && selected.maxGroup != null && selected.maxGroup < 4)"
            (click)="selected.groupIndex = 4"><span class="text">
              Documents
            </span>
            <div class="dot"></div>
          </button>
        </div>
        <div *ngIf="selected.groupIndex == 0" class="fields">
          <div class="input-area" *ngVar="selected.isEditing() as editing" [ngClass]="{minimal: !editing}">
            <div class="input-container" *ngVar="selected.name as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{double: !selected.isNew(), error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Compass Name</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The name of the compass.', 'Asthma Compass')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input #autofocus type="text" class="input" maxlength="50" placeholder="Asthma Compass"
                (blur)="field.touch()" [(ngModel)]="field.value"
                [disabled]="!(selected.isDraft() && field.isEditable())" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div *ngIf="selected.isRejected()" class="input-container double" [title]="selected.rejectReason || 'None'">
              <div class="label-line">
                <span class="label">Reject Reason</span>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The reason that this compass was rejected.')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <textarea textareaAutoheight class="input" placeholder="None" [(ngModel)]="selected.rejectReason"
                disabled></textarea>
            </div>
            <div *ngIf="!selected.isNew()" class="input-container" [title]="selected.getStatusText()">
              <div class="label-line">
                <span class="label">Publish Status</span>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The current publish status of the compass.  Can be Draft, In Review, Private, Protected, Public, or Archived.')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" [ngModel]="selected.getStatusText()" disabled />
            </div>
            <div class="input-container" *ngVar="selected.providerName as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Provider</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The name of the provider that the compass is associated with.', 'Huddy Health')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="Huddy Health" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                [disabled]="!(selected.isDraft() && field.isEditable())">
                <mat-option class="empty-option" [value]="null">None</mat-option>
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container" *ngVar="selected.scoreName as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Score Name</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The name will appear on the score card for the compass.', 'Asthma Score')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" maxlength="50" placeholder="Asthma Score" (blur)="field.touch()"
                [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container" *ngVar="selected.conditionName as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Condition Name</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The name of the condition that the compass is associated with.', 'Asthma')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" maxlength="255" placeholder="Asthma" (blur)="field.handleBlur($event)"
                [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())"
                [matAutocomplete]="conditionAutocomplete" />
              <mat-autocomplete #conditionAutocomplete="matAutocomplete" (closed)="field.touch()">
                <mat-option *ngIf="field.loading" disabled>
                  <mat-progress-spinner class="spinner option-spinner" color="primary" mode="indeterminate"
                    diameter="31">
                  </mat-progress-spinner>
                </mat-option>
                <mat-option *ngFor="let option of (field.loading ? [] : field.autocompleteOptions)"
                  [value]="option.displayValue" (click)="field.handleSelection(option)">
                  {{option.displayValue}}
                </mat-option>
              </mat-autocomplete>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container" *ngVar="selected.useCustomScoreClass as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{double: !selected.usesCustomScoreClass(), error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Use Custom Score Class</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'Use a custom class to determine the compass\'s score.', 'No')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="No" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                [disabled]="!(selected.isDraft() && field.isEditable())">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container" *ngVar="selected.scoreClass as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{hidden: !selected.usesCustomScoreClass(), error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Score Class</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The name of the custom class used to determine the compass\'s score.', 'AsthmaScoreCalculator')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" maxlength="64" placeholder="AsthmaScoreCalculator" (blur)="field.touch()"
                [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container double" *ngVar="selected.description as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Description</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The description of the compass that will be used in the Guidance Subscription presented to users.', 'Helps users suffering from Asthma track and evaluate their symptoms')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <div class="input-inner-container">
                <label for="description" class="hitbox text"></label>
                <textarea textareaAutoheight id="description" class="input" maxlength="255"
                  placeholder="Helps users suffering from Asthma track and evaluate their symptoms"
                  (blur)="field.touch()" [(ngModel)]="field.value"
                  [disabled]="!(selected.isDraft() && field.isEditable())"></textarea>
                <span class="error-message">{{field.getDisplayedIssue()}}</span>
              </div>
            </div>
            <div class="input-container double" *ngVar="selected.longDescription as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Product Page Description</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The description of the compass that will be used on the product page where a user might purchase it.', 'Helps users suffering from Asthma track and evaluate their symptoms')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <div class="input-inner-container">
                <label for="description" class="hitbox text"></label>
                <textarea textareaAutoheight id="description" class="input" maxlength="2048"
                  placeholder="Helps users suffering from Asthma track and evaluate their symptoms"
                  (blur)="field.touch()" [(ngModel)]="field.value"
                  [disabled]="!(selected.isDraft() && field.isEditable())"></textarea>
                <span class="error-message">{{field.getDisplayedIssue()}}</span>
              </div>
            </div>
            <div class="input-container double" *ngVar="selected.scoreGroupsGroup as group"
              [ngClass]="{hidden: selected.usesCustomScoreClass()}">
              <div class="label-line">
                <span class="label">Score Group Names</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'A names of the score groups, which each get independently scored based on trackable scales and assessment questions.')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <div class="input bubbles"
                *ngVar="(editing && !selected.isSingleGroup() && selected.canAddRemoveScaleRanges()) as canRemove">
                <div *ngFor="let scoreGroup of selected.scoreGroups; index as i" class="bubble"
                  [ngClass]="{'with-button': canRemove, disabled: !(selected.isDraft() && scoreGroup.name.isEditable())}">
                  <input [inputAutowidth]="canRemove ? 69 : 52" *ngVar="scoreGroup.name as field" type="text"
                    maxlength="20" class="bubble-input" placeholder="Group" (blur)="field.touch()"
                    [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
                  <button mat-button *ngIf="canRemove" class="button text-button" tabindex="-1"
                    [disabled]="!selected.isDraft()"
                    (click)="removeScoreGroup(selected, i); selected.scoreGroupStatusField.touch();">
                    <img src="assets/content-icon/ic-05.svg" class="icon" />
                  </button>
                </div>
                <button mat-button class="bubble button"
                  *ngIf="selected.canAddRemoveScaleRanges() && selected.isDraft()" (click)="addScoreGroup(selected)">
                  <img src="assets/content-icon/ic-04.svg" class="icon" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="selected.groupIndex == 1" class="fields">
          <div *ngIf="selected.trackables.length == 0" class="empty-state"
            [ngClass]="{error: selected.trackableStatusField.getDisplayedIssue()}">
            {{selected.trackableStatusField.getDisplayedIssue() || 'Nothing to show'}}
          </div>
          <div (ngInit)="scrollToNew($event)" [collapsible]="'trackables[' + i + ']'" [ecController]="ecController"
            class="input-area card has-title no-overflow" *ngFor="let trackable of selected.trackables; index as i"
            [ngClass]="{minimal: !(selected.isEditing(trackable) || selected.isEditing()),
              dirty: trackable.isDirty() || (selected.isDirty() && trackable.isNew), invalid: trackable.hasVisibleIssue()}">
            <div class="double card-title">
              <span class="title clickable" (click)="toggleCollapsed(trackable, 'trackables[' + i + ']')">
                <span class="number">{{i + 1}}:</span>{{(trackable.name?.value || '').trim() || 'Trackable'}}
              </span>
              <div class="dot"></div>
              <button mat-button *ngIf="selected.isDraft() && !(selected.isEditing(trackable) || selected.isEditing())"
                class="text-button edit-button" tabindex="-1" title="Edit"
                (click)="$event.stopPropagation(); selected.edit(trackable)">
                <img src="assets/edit-no-whitespace.svg" class="icon" />
              </button>
              <div class="title-buttons">
                <button mat-button
                  *ngIf="selected.isDraft() && (selected.isEditing(trackable) || selected.isEditing()) && trackable.isIntegratedTrackable()"
                  class="text-button button custom-color custom-size warn"
                  (click)="$event.stopPropagation(); trackable.clearIntegration()">
                  Remove integration
                </button>
                <button mat-button class="text-button button"
                  (click)="toggleCollapsed(trackable, 'trackables[' + i + ']')">
                  <img src="assets/content-icon/ic-16.svg" class="icon arrow" />
                </button>
              </div>
            </div>
            <div class="input-container" *ngVar="trackable.name as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !trackable.isNew && field.isDirty()}">
              <div class="label-line">
                <span class="label">Trackable Name</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The name of the trackable.', 'Inhaler uses')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" maxlength="50" placeholder="Inhaler uses"
                (blur)="field.touchOrOption($event)" (focus)="trackableNameFieldFocused(field)"
                [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())"
                [simpleAutocomplete]="trackableAutocomplete"
                (optionSelected)="handleAutocompleteTrackableSelection($event, trackable)" (closed)="field.touch()" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container" *ngVar="trackable.trackableType as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !trackable.isNew && field.isDirty()}">
              <div class="label-line">
                <span class="label">Trackable Type</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The type of the trackable.', 'Evidence')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="Evidence" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                [disabled]="!(selected.isDraft() && field.isEditable())">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container double" *ngVar="trackable.integrations as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !trackable.isNew && (field.isDirty() || trackable.isIntegrated.isDirty()), hidden: !trackable.isIntegratedTrackable()}">
              <div class="label-line">
                <span class="label">Allowed Integrations</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The integrations that a compass user may choose from to provide the data for this trackable.', 'HealthKit')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select multiple class="input select" placeholder="None" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                [disabled]="!(selected.isDraft() && field.isEditable())">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container" *ngVar="trackable.unitsOfMeasure as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !trackable.isNew && field.isDirty(), hidden: !trackable.isEvidence()}">
              <div class="label-line">
                <span class="label">Units</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The name of the units used by the evidence.', 'Uses per day')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" maxlength="255" placeholder="Uses per day" (blur)="field.touch()"
                [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container" *ngVar="trackable.normalValue as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !trackable.isNew && field.isDirty(), hidden: !trackable.isEvidence()}">
              <div class="label-line">
                <span class="label">Normal Value</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The typical value for the evidence.', '0')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="0" (blur)="field.touch()"
                [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container double" *ngVar="trackable.additive as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !trackable.isNew && field.isDirty(), hidden: !trackable.isEvidence()}">
              <div class="label-line">
                <span class="label">Is Additive</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'Aggregates multiple measurements for the evidence on the same day by adding their values rather than averaging them.', 'Yes')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="Yes" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                [disabled]="!(selected.isDraft() && field.isEditable())">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div
              *ngIf="!selected.usesCustomScoreClass() && (selected.isEditing() || selected.isEditing(trackable) || trackable.scales?.length > 0)"
              class="double">
              <div class="subheader-line" *ngVar="trackable.scalesGroup as group"
                [ngClass]="{dirty: !trackable.isNew && group.isDirty(), error: group.hasVisibleIssue()}">
                <div class="subheader-text">
                  <span class="subheader">{{selected.isSingleGroup() ? 'Scale' : 'Scales'}}</span>
                  <div class="dot"></div>
                  <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                    (click)="showFieldInfo($event, selected.isSingleGroup() ? 'A scale to score this trackable.' : 'A set of scales to score this trackable, each contributing to different score groups.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <button mat-button class="text-button subheader-button custom-size custom-color"
                  *ngIf="trackable.canEditScale() && (!selected.isSingleGroup() || trackable.scales.length == 0)"
                  (click)="openPieceManager('TRACKABLE_SCALE', trackable)">
                  Add from templates
                </button>
                <button mat-button
                  *ngIf="trackable.canEditScale() && (!selected.isSingleGroup() || trackable.scales.length == 0)"
                  class="text-button subheader-button custom-size custom-color" [disabled]="!selected.isDraft()"
                  (click)="addTrackableScale(trackable, i)">
                  Add new scale
                </button>
              </div>
              <div *ngIf="trackable.scales.length == 0" class="empty-state"
                [ngClass]="{error: trackable.statusField.getDisplayedIssue()}">
                {{trackable.statusField.getDisplayedIssue() || 'Nothing to show'}}
              </div>
              <div (ngInit)="scrollToNew($event)" [collapsible]="'trackables[' + i + ']scales[' + j + ']'"
                [ecController]="ecController" class="card input-area no-overflow"
                *ngFor="let scale of trackable.scales; index as j"
                [ngClass]="{minimal: !(selected.isEditing(trackable) || selected.isEditing()), dirty: scale.isDirty() || (trackable.isDirty() && scale.isNew), invalid: scale.hasVisibleIssue()}">
                <button mat-button class="text-button corner-button preserve"
                  (click)="toggleCollapsed(scale, 'trackables[' + i +']scales[' + j + ']')">
                  <img src="assets/content-icon/ic-16.svg" class="icon arrow" />
                </button>
                <span class="error-message">{{scale.statusField.getDisplayedIssue()}}</span>
                <div class="input-container" *ngVar="scale.groupGuids as field"
                  [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !scale.isNew && field.isDirty(), hidden: selected.isSingleGroup()}">
                  <div class="label-line">
                    <span class="label">Score Groups</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The names of the groups that this scale will contribute to.', 'Breathing Qualtiy')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <mat-select multiple class="input select" placeholder="None"
                    (openedChange)="field.openedChange($event)" (blur)="field.handleBlur($event)"
                    [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())">
                    <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                      {{option.displayValue}}
                    </mat-option>
                  </mat-select>
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <div class="input-container" *ngVar="scale.scaleType as field"
                  [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !scale.isNew && field.isDirty(), double: selected.isSingleGroup()}">
                  <div class="label-line">
                    <span class="label">Scale Type</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'Determines how to aggregate measurement values for this scale.  \'Sum\' adds the measurement values over the interval, \'Average\' averages them, and \'Count\' both averages and counts them.', 'Sum')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <mat-select class="input select" placeholder="None" (openedChange)="field.openedChange($event)"
                    (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                    [disabled]="!(selected.isDraft() && field.isEditable())">
                    <mat-option class="empty-option" [value]="null">None</mat-option>
                    <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                      {{option.displayValue}}
                    </mat-option>
                  </mat-select>
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <div *ngIf="scale.scaleType.value != null" class="double">
                  <div class="subheader-line" *ngVar="scale.scaleRangesGroup as group"
                    [ngClass]="{dirty: !scale.isNew && group.isDirty(), error: group.hasVisibleIssue()}">
                    <div class="subheader-text">
                      <span class="subheader">Scale Ranges</span>
                      <div class="dot"></div>
                      <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                        (click)="showFieldInfo($event, 'The set of disjoint ranges that will determine the score for this scale.')">
                        <img src="assets/ic_information_blk.svg" class="icon" />
                      </button>
                    </div>
                    <button mat-button *ngIf="scale.canEditScale()"
                      class="text-button subheader-button custom-size custom-color" [disabled]="!selected.isDraft()"
                      (click)="scale.addScaleRange(); setShouldScrollToNew()">
                      Add scale range
                    </button>
                  </div>
                  <div *ngIf="scale.scaleRanges.length == 0" class="empty-state"
                    [ngClass]="{error: scale.statusField.getDisplayedIssue()}">
                    {{scale.statusField.getDisplayedIssue() || 'Nothing to show'}}
                  </div>
                  <div (ngInit)="scrollToNew($event)" class="card input-area"
                    *ngFor="let range of scale.scaleRanges; index as k"
                    [ngClass]="{minimal: !(selected.isEditing(trackable) || selected.isEditing()), dirty: range.isDirty() || (scale.isDirty() && range.isNew), invalid: range.hasVisibleIssue()}">
                    <button mat-button *ngIf="scale.canEditScale()" class="text-button corner-button"
                      [title]="selected.isDraft() ? 'Remove scale range' : ''" [disabled]="!selected.isDraft()"
                      (click)="scale.removeScaleRange(range.id); scale.statusField.touch();">
                      <img src="assets/content-icon/ic-05.svg" class="icon" />
                    </button>
                    <span class="error-message">{{range.statusField.getDisplayedIssue()}}</span>
                    <div class="input-container" *ngVar="translateRangeIndex(k) as rangeId" [title]="rangeId">
                      <div class="label-line">
                        <span class="label">Range ID</span>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'An identifier for the scale range that is unique among trackable scale ranges within the trackable.')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input type="text" class="input" [ngModel]="rangeId" disabled />
                    </div>
                    <div class="input-container" *ngVar="range.weight as field"
                      [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                      [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                      <div class="label-line">
                        <span class="label">Weight</span>
                        <div class="dirty-dot"></div>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'The value that the scale range will contribute to the compass\'s scale value if its conditions are met.', '10')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="10"
                        (blur)="field.touch()" [(ngModel)]="field.value"
                        [disabled]="!(selected.isDraft() && field.isEditable())" />
                      <span class="error-message">{{field.getDisplayedIssue()}}</span>
                    </div>
                    <div class="input-container" *ngVar="range.minimum as field"
                      [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                      [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                      <div class="label-line">
                        <span class="label">Minimum</span>
                        <div class="dirty-dot"></div>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'The inclusive minimum aggregated measurement value over some interval required for the scale range to be applied.', '0')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="0"
                        (blur)="range.touchMinMax(field)" [(ngModel)]="field.value"
                        [disabled]="!(selected.isDraft() && field.isEditable())" />
                      <span class="error-message">{{field.getDisplayedIssue()}}</span>
                    </div>
                    <div class="input-container" *ngVar="range.maximum as field"
                      [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                      [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                      <div class="label-line">
                        <span class="label">Maximum</span>
                        <div class="dirty-dot"></div>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'The exclusive maximum aggregated measurement value over some interval required for the scale range to be applied.', range.isSum() ? '7' : '1')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input numberInput [int]="field.isInt()" type="text" class="input"
                        [placeholder]="range.isSum() ? '7' : '1'" (blur)="range.touchMinMax(field)"
                        [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
                      <span class="error-message">{{field.getDisplayedIssue()}}</span>
                    </div>
                    <div class="input-container" *ngVar="range.countMinimum as field"
                      [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                      [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty(), hidden: !range.isCount()}">
                      <div class="label-line">
                        <span class="label">Count Minimum</span>
                        <div class="dirty-dot"></div>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'The inclusive minimum number of measurements logged over some interval required for the scale range to be applied.', '1')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="1"
                        (blur)="range.touchCountMinMax(field)" [(ngModel)]="field.value"
                        [disabled]="!(selected.isDraft() && field.isEditable())" />
                      <span class="error-message">{{field.getDisplayedIssue()}}</span>
                    </div>
                    <div class="input-container" *ngVar="range.countMaximum as field"
                      [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                      [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty(), hidden: !range.isCount()}">
                      <div class="label-line">
                        <span class="label">Count Maximum</span>
                        <div class="dirty-dot"></div>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'The inclusive maximum number of measurements logged over some interval required for the scale range to be applied.', '7')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="7"
                        (blur)="range.touchCountMinMax(field)" [(ngModel)]="field.value"
                        [disabled]="!(selected.isDraft() && field.isEditable())" />
                      <span class="error-message">{{field.getDisplayedIssue()}}</span>
                    </div>
                  </div>
                </div>
                <div class="card-bottom-buttons double">
                  <button mat-button *ngIf="scale.scaleRanges.length > 0" class="button text-button custom-size"
                    (click)="addTrackableScalePiece(scale)">
                    Save scale as template
                  </button>
                  <button mat-button *ngIf="trackable.canEditScale()"
                    class="button text-button custom-size custom-color warn" [disabled]="!selected.isDraft()"
                    (click)="removeTrackableScale(trackable, i, j); trackable.statusField.touch();">
                    Remove scale
                  </button>
                </div>
              </div>
            </div>
            <div class="card-bottom-buttons double">
              <button mat-button *ngIf="trackable.canRemove()" class="button text-button custom-size custom-color warn"
                [disabled]="!selected.isDraft()"
                (click)="removeTrackable(selected, i); selected.trackableStatusField.touch();">
                Remove trackable
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="selected.groupIndex == 2" class="fields">
          <div class="input-area" [ngClass]="{'shallow-minimal': !selected.isEditing()}">
            <div class="input-container double" *ngVar="selected.conclusionText as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Conclusion Text</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The text that is shown to the user at the end of the assessment.', 'Asthma assessment completed')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <div class="input-inner-container">
                <label for="conclusionText" class="hitbox text"></label>
                <textarea #autofocus textareaAutoheight id="conclusionText" class="input"
                  placeholder="Asthma assessment completed" (blur)="field.touch()" [(ngModel)]="field.value"
                  [disabled]="!(selected.isDraft() && field.isEditable())"></textarea>
                <span class="error-message">{{field.getDisplayedIssue()}}</span>
              </div>
            </div>
            <div class="input-container double" *ngVar="selected.attribution as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Attribution</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The attribution for the source of the information.', 'WebMD')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <div class="input-inner-container">
                <label for="attribution" class="hitbox text"></label>
                <textarea textareaAutoheight id="attribution" class="input" placeholder="WebMD" (blur)="field.touch()"
                  [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())"></textarea>
                <span class="error-message">{{field.getDisplayedIssue()}}</span>
              </div>
            </div>
            <div class="input-container double" *ngVar="selected.attributionLink as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Attribution Link</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'A link for more information about the source of the information.', 'https://www.webmd.com/asthma/what-is-asthma')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" placeholder="https://www.webmd.com/asthma/what-is-asthma"
                (blur)="field.touch()" [(ngModel)]="field.value"
                [disabled]="!(selected.isDraft() && field.isEditable())" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container" *ngVar="selected.showPreviousAnswers as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Show Previous Answers</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'Show users the answers from their previous assessment while taking the assessment.', 'Yes')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="Yes" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                [disabled]="!(selected.isDraft() && field.isEditable())">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container" *ngVar="selected.hasHuddyReminder as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Has Huddy Reminder</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'Gives users a reminder to take this assessment.', 'Yes')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="Yes" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                [disabled]="!(selected.isDraft() && field.isEditable())">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div *ngIf="selected.hasReminder()" class="subheader-line double"
              [ngClass]="{dirty: selected.reminderGroup.isDirty() && !selected.isNew(), error: selected.reminderGroup.hasVisibleIssue()}">
              <div class="subheader-text">
                <span class="subheader">Reminder</span>
                <div class="dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'A reminder that shows up if a user hasn\'t taken the assessment in the specified amount of time.')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
            </div>
            <div class="input-container double" *ngVar="selected.reminderPrompt as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty(), hidden: !selected.hasReminder()}">
              <div class="label-line">
                <span class="label">Prompt</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'Text to prompt the user.', 'Don\'t forget to complete your Asthma assessment')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" maxlength="128"
                placeholder="Don't forget to complete your Asthma assessment" (blur)="field.touch()"
                [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container double" *ngVar="selected.reminderCaredForPrompt as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty(), hidden: !selected.hasReminder()}">
              <div class="label-line">
                <span class="label">Journaled For Prompt</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'Text to prompt the user when the assessment is for a journaled for user.  Use \'\{\{username\}\}\' to show the user\'s name and \'\{\{logForName\}\}\' to show the journaled for user\'s name.', '\{\{logForName\}\}, don\'t forget to complete your Asthma assessment')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" maxlength="128"
                [placeholder]="'\{\{logForName\}\}, don\'t forget to complete your Asthma assessment'"
                (blur)="field.touch()" [(ngModel)]="field.value"
                [disabled]="!(selected.isDraft() && field.isEditable())" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container" *ngVar="selected.reminderDaysBetween as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty(), hidden: !selected.hasReminder()}">
              <div class="label-line">
                <span class="label">Days Between</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The number of days after taking an assessment that the reminder should be shown.', '7')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="7" (blur)="field.touch()"
                [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="input-container" *ngVar="selected.reminderButtonText as field"
              [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty(), hidden: !selected.hasReminder()}">
              <div class="label-line">
                <span class="label">Button Text</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The text that shows up on the button for the prompt.', 'Take assessment')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" maxlength="24" class="input" placeholder="Take assessment" (blur)="field.touch()"
                [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <div class="double">
              <div class="subheader-line" *ngVar="selected.answerablesGroup as group"
                [ngClass]="{dirty: group.isDirty() && !selected.isNew(), error: group.hasVisibleIssue()}">
                <div class="subheader-text">
                  <span class="subheader">Questions</span>
                  <div class="dot"></div>
                  <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                    (click)="showFieldInfo($event, 'The questions that make up the assessment.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <button mat-button class="text-button subheader-button custom-size custom-color"
                  *ngIf="selected.isDraft()" (click)="openPieceManager('QUESTION', selected)">
                  Add from templates
                </button>
                <button mat-button class="text-button subheader-button custom-size custom-color"
                  *ngIf="selected.isDraft()" (click)="addAnswerable(selected)">
                  Add new question
                </button>
              </div>
              <div *ngIf="selected.answerables.length == 0" class="empty-state"
                [ngClass]="{error: selected.answerableStatusField.getDisplayedIssue()}">
                {{selected.answerableStatusField.getDisplayedIssue() || 'Nothing to show'}}
              </div>
              <div class="card-container" *ngFor="let answerable of selected.answerables; index as i"
                [ngClass]="{invalid: answerable.hasVisibleIssue()}">
                <span class="error-message">{{answerable.statusField.getDisplayedIssue()}}</span>
                <div (ngInit)="scrollToNew($event)" [collapsible]="'answerables[' + i + ']'"
                  [ecController]="ecController" class="card title-only no-overflow input-area"
                  [ngClass]="{minimal: !(selected.isEditing() || selected.isEditing(answerable)),
                dirty: answerable.isDirty() || (selected.isDirty() && answerable.isNew), invalid: answerable.hasVisibleIssue()}">
                  <div class="double card-title">
                    <span class="title clickable" (click)="toggleCollapsed(answerable, 'answerables[' + i + ']')">
                      <span class="number">{{i + 1}}:</span>{{(answerable.question?.value || '').trim() || 'Question'}}
                    </span>
                    <div class="dot"></div>
                    <button mat-button
                      *ngIf="selected.isDraft() && !(selected.isEditing(answerable) || selected.isEditing())"
                      class="text-button edit-button" tabindex="-1" title="Edit"
                      (click)="$event.stopPropagation(); selected.edit(answerable)">
                      <img src="assets/edit-no-whitespace.svg" class="icon" />
                    </button>
                    <div class="title-buttons">
                      <button mat-button class="text-button button title-button custom-size custom-color"
                        (click)="previewAssessment(selected, i)">
                        Preview
                      </button>
                      <button mat-button class="text-button button title-button custom-size custom-color"
                        *ngIf="i > 0 && selected.isDraft() && (selected.isEditing(answerable) || selected.isEditing())"
                        (click)="moveAnswerable(selected, i, i - 1)">
                        Move up
                      </button>
                      <button mat-button class="text-button button title-button custom-size custom-color"
                        *ngIf="i < selected.answerables.length - 1 && selected.isDraft() && (selected.isEditing(answerable) || selected.isEditing())"
                        (click)="moveAnswerable(selected, i, i + 1)">
                        Move down
                      </button>
                      <button mat-button class="text-button button"
                        (click)="toggleCollapsed(answerable, 'answerables[' + i + ']')">
                        <img src="assets/content-icon/ic-16.svg" class="icon arrow" />
                      </button>
                    </div>
                  </div>
                  <div class="input-container double" *ngVar="answerable.question as field"
                    [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                    [ngClass]="{error: field.getDisplayedIssue(), dirty: !answerable.isNew && field.isDirty()}">
                    <div class="label-line">
                      <span class="label">Question</span>
                      <div class="dirty-dot"></div>
                      <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                        (click)="showFieldInfo($event, 'The question text that will show up in the assessment.', 'How many times have you used your inhaler in the last week?')">
                        <img src="assets/ic_information_blk.svg" class="icon" />
                      </button>
                    </div>
                    <input type="text" class="input"
                      placeholder="How many times have you used your inhaler in the last week?" (blur)="field.touch()"
                      [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
                    <span class="error-message">{{field.getDisplayedIssue()}}</span>
                  </div>
                  <div class="input-container double" *ngVar="answerable.caredForQuestion as field"
                    [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                    [ngClass]="{error: field.getDisplayedIssue(), dirty: !answerable.isNew && field.isDirty()}">
                    <div class="label-line">
                      <span class="label">Journaled For Question</span>
                      <div class="dirty-dot"></div>
                      <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                        (click)="showFieldInfo($event, 'The question text that will show up in the assessment when it is taken for a journaled for user.  Use \'\{\{username\}\}\' to show the user\'s name and \'\{\{logForName\}\}\' to show the journaled for user\'s name.', 'How many times have you used your inhaler in the last week?')">
                        <img src="assets/ic_information_blk.svg" class="icon" />
                      </button>
                    </div>
                    <input type="text" class="input"
                      placeholder="How many times have you used your inhaler in the last week?" (blur)="field.touch()"
                      [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
                    <span class="error-message">{{field.getDisplayedIssue()}}</span>
                  </div>
                  <div class="input-container" *ngVar="answerable.answerType as field"
                    [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
                    [ngClass]="{double: !answerable.isButton(), error: field.getDisplayedIssue(), dirty: !answerable.isNew && field.isDirty()}">
                    <div class="label-line">
                      <span class="label">Answer Type</span>
                      <div class="dirty-dot"></div>
                      <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                        (click)="showFieldInfo($event, 'The type of answer to get for the question.', 'Button')">
                        <img src="assets/ic_information_blk.svg" class="icon" />
                      </button>
                    </div>
                    <mat-select class="input select" placeholder="Button" (openedChange)="field.openedChange($event)"
                      (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                      [disabled]="!(selected.isDraft() && field.isEditable())">
                      <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                        {{option.displayValue}}
                      </mat-option>
                    </mat-select>
                    <span class="error-message">{{field.getDisplayedIssue()}}</span>
                  </div>
                  <div class="input-container" *ngVar="answerable.parentQuestionNumber as field"
                  [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty:  field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Parent Question</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The number of the parent question this is part of - will be presented as a question/answer grid.', '1')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="1"
                     [(ngModel)]="field.value"
                    [disabled]="!(selected.isDraft() && field.isEditable())" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                  <div class="input-container" *ngVar="answerable.multiAnswer as field"
                    [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
                    [ngClass]="{error: field.getDisplayedIssue(), dirty: !answerable.isNew && field.isDirty(), hidden: !answerable.isButton()}">
                    <div class="label-line">
                      <span class="label">Is Multi-Answer</span>
                      <div class="dirty-dot"></div>
                      <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                        (click)="showFieldInfo($event, 'Allow the user to select multiple buttons buttons rather than just one.', 'No')">
                        <img src="assets/ic_information_blk.svg" class="icon" />
                      </button>
                    </div>
                    <mat-select class="input select" placeholder="No" (openedChange)="field.openedChange($event)"
                      (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                      [disabled]="!(selected.isDraft() && field.isEditable())">
                      <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                        {{option.displayValue}}
                      </mat-option>
                    </mat-select>
                    <span class="error-message">{{field.getDisplayedIssue()}}</span>
                  </div>
                  <div
                    *ngIf="answerable.isButton() && (selected.isEditing() || selected.isEditing(answerable) || answerable.buttons?.length > 0)"
                    class="double">
                    <div class="subheader-line" *ngVar="answerable.buttonsGroup as group"
                      [ngClass]="{dirty: !answerable.isNew && group.isDirty(), error: group.hasVisibleIssue()}">
                      <div class="subheader-text">
                        <span class="subheader">Buttons</span>
                        <div class="dot"></div>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'The buttons that the user can choose from to answer the question.')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <button mat-button *ngIf="answerable.canAddRemoveButtons()"
                        class="text-button subheader-button custom-size custom-color" [disabled]="!selected.isDraft()"
                        (click)="addAnswerableButton(answerable, i)">
                        Add new button
                      </button>
                    </div>
                    <div *ngIf="answerable.buttons.length == 0" class="empty-state">
                      Nothing to show
                    </div>
                    <div (ngInit)="scrollToNew($event)" [collapsible]="'answerables[' + i + ']buttons[' + j + ']'"
                      [ecController]="ecController" class="card input-area no-overflow"
                      *ngFor="let button of answerable.buttons; index as j"
                      [ngClass]="{dirty: button.isDirty() || (answerable.isDirty() && button.isNew), invalid: button.hasVisibleIssue()}">
                      <!-- <button mat-button *ngIf="answerable.canAddRemoveButtons()" class="text-button corner-button" [disabled]="!selected.isDraft()" (click)="removeAnswerableButton(answerable, i, j); answerable.statusField.touch();">
                              <img src="assets/content-icon/ic-05.svg" class="icon" />
                            </button> -->
                      <button mat-button class="text-button corner-button preserve"
                        (click)="toggleCollapsed(button, 'answerables[' + i + ']buttons[' + j + ']')">
                        <img src="assets/content-icon/ic-16.svg" class="icon arrow" />
                      </button>
                      <span class="error-message">{{button.statusField.getDisplayedIssue()}}</span>
                      <div class="input-container double" *ngVar="button.answer as field"
                        [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                        [ngClass]="{error: field.getDisplayedIssue(), dirty: !button.isNew && field.isDirty()}">
                        <div class="label-line">
                          <span class="label">Button Text</span>
                          <div class="dirty-dot"></div>
                          <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                            (click)="showFieldInfo($event, 'The text that shows up in the button.', '1 - 3 times')">
                            <img src="assets/ic_information_blk.svg" class="icon" />
                          </button>
                        </div>
                        <input type="text" class="input" placeholder="1 - 3 times" (blur)="field.touch()"
                          [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
                        <span class="error-message">{{field.getDisplayedIssue()}}</span>
                      </div>
                      <div class="input-container double" *ngVar="button.flow as field"
                      [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                      [ngClass]="{error: field.getDisplayedIssue(), dirty: !button.isNew && field.isDirty()}">
                      <div class="label-line">
                        <span class="label">Go To</span>
                        <div class="dirty-dot"></div>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'If this button is the answer, the question number of the question to go to if not the next question.', '12')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input type="text" class="input" placeholder="12" (blur)="field.touch()"
                        [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
                      <span class="error-message">{{field.getDisplayedIssue()}}</span>
                    </div>
                      <div *ngIf="!selected.usesCustomScoreClass()" class="double">
                        <div class="subheader-line" *ngVar="button.weightsGroup as group"
                          [ngClass]="{dirty: !button.isNew && group.isDirty(), error: group.hasVisibleIssue()}">
                          <div class="subheader-text">
                            <span class="subheader">{{selected.isSingleGroup() ? 'Weight' : 'Weights'}}</span>
                            <div class="dot"></div>
                            <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                              (click)="showFieldInfo($event, selected.isSingleGroup() ? 'A weight to score this question.' : 'A set of weights to score this question, each contributing to different score groups.')">
                              <img src="assets/ic_information_blk.svg" class="icon" />
                            </button>
                          </div>
                          <button mat-button *ngIf="!selected.isSingleGroup() || button.weights.length == 0"
                            class="text-button subheader-button custom-size custom-color"
                            [disabled]="!selected.isDraft()" (click)="button.addWeight(); setShouldScrollToNew()">
                            Add new weight
                          </button>
                        </div>
                        <div *ngIf="button.weights.length == 0" class="empty-state">
                          Nothing to show
                        </div>
                        <div (ngInit)="scrollToNew($event)" class="card input-area"
                          *ngFor="let weight of button.weights; index as i"
                          [ngClass]="{dirty: weight.isDirty() || (button.isDirty() && weight.isNew), invalid: weight.hasVisibleIssue()}">
                          <button mat-button class="text-button corner-button" [disabled]="!selected.isDraft()"
                            (click)="button.removeWeight(i); button.statusField.touch();">
                            <img src="assets/content-icon/ic-05.svg" class="icon" />
                          </button>
                          <span class="error-message">{{weight.statusField.getDisplayedIssue()}}</span>
                          <div class="input-container" *ngVar="weight.groupGuids as field"
                            [title]="(selected.isDraft() && field.isEditable()) ? '' : field.getDisplayValue()"
                            [ngClass]="{error: field.getDisplayedIssue(), dirty: !weight.isNew && field.isDirty(), hidden: selected.isSingleGroup()}">
                            <div class="label-line">
                              <span class="label">Score Groups</span>
                              <div class="dirty-dot"></div>
                              <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                                (click)="showFieldInfo($event, 'The names of the groups that this weight will contribute to.', 'Breathing Quality')">
                                <img src="assets/ic_information_blk.svg" class="icon" />
                              </button>
                            </div>
                            <mat-select multiple class="input select" placeholder="None"
                              (openedChange)="field.openedChange($event)" (blur)="field.handleBlur($event)"
                              [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())">
                              <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                                {{option.displayValue}}
                              </mat-option>
                            </mat-select>
                            <span class="error-message">{{field.getDisplayedIssue()}}</span>
                          </div>
                          <div class="input-container" *ngVar="weight.value as field"
                            [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                            [ngClass]="{hidden: selected.usesCustomScoreClass(), error: field.getDisplayedIssue(), dirty: !weight.isNew && field.isDirty(), double: selected.isSingleGroup()}">
                            <div class="label-line">
                              <span class="label">Weight</span>
                              <div class="dirty-dot"></div>
                              <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                                (click)="showFieldInfo($event, 'The value that this this button will contribute if it is selected by the user.', '10')">
                                <img src="assets/ic_information_blk.svg" class="icon" />
                              </button>
                            </div>
                            <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="10"
                              (blur)="field.touch()" [(ngModel)]="field.value"
                              [disabled]="!(selected.isDraft() && field.isEditable())" />
                            <span class="error-message">{{field.getDisplayedIssue()}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="card-bottom-buttons double">
                        <button mat-button *ngIf="answerable.canAddRemoveButtons()"
                          class="button text-button custom-size custom-color warn" [disabled]="!selected.isDraft()"
                          (click)="removeAnswerableButton(answerable, i, j); answerable.statusField.touch();">
                          Remove button
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="card-bottom-buttons double">
                    <button mat-button class="button text-button custom-size" (click)="addQuestionPiece(answerable)">
                      Save question as template
                    </button>
                    <button mat-button *ngIf="answerable.canRemove()"
                      class="button text-button custom-size custom-color warn" [disabled]="!selected.isDraft()"
                      (click)="removeAnswerable(selected, i); selected.answerableStatusField.touch();">
                      Remove question
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="selected.groupIndex == 3" class="fields">
          <div class="input-area" [ngClass]="{'shallow-minimal': !selected.isEditing()}">
            <div class="double" *ngVar="selected.scoreGroupsGroup as group">
              <div *ngIf="!selected.isSingleGroup()" class="subheader-line"
                [ngClass]="{dirty: group.isDirty() && !selected.isNew(), error: group.hasVisibleIssue()}">
                <div class="subheader-text">
                  <span class="subheader">Score Groups</span>
                  <div class="dot"></div>
                  <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                    (click)="showFieldInfo($event, 'A set of groups that each get independently scored based on trackable scales and assessment questions.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <button mat-button *ngIf="selected.canAddRemoveScaleRanges()"
                  class="text-button subheader-button custom-size custom-color" [disabled]="!selected.isDraft()"
                  (click)="addScoreGroup(selected)">
                  Add new score group
                </button>
              </div>
              <div *ngIf="selected.scoreGroups.length == 0" class="empty-state"
                [ngClass]="{error: selected.scoreGroupStatusField.getDisplayedIssue()}">
                {{selected.scoreGroupStatusField.getDisplayedIssue() || 'Nothing to show'}}
              </div>
              <div (ngInit)="scrollToNew($event)" [collapsible]="'scoreGroups[' + i + ']'" [ecController]="ecController"
                class="card input-area has-title no-overflow"
                *ngFor="let scoreGroup of selected.scoreGroups; index as i"
                [ngClass]="{dirty: scoreGroup.isDirty() || (selected.isDirty() && scoreGroup.isNew()), invalid: scoreGroup.hasVisibleIssue(),
                                  'hidden-wrapper': selected.isSingleGroup(), minimal: !(selected.isEditing() || selected.isEditing(scoreGroup))}">
                <div *ngIf="!selected.isSingleGroup()" class="double card-title">
                  <span class="title clickable"
                    (click)="toggleCollapsed(scoreGroup, 'scoreGroups[' + i + ']')">{{(scoreGroup.name?.value ||
                    '').trim() || 'Score Group'}}</span>
                  <div class="dot"></div>
                  <button mat-button
                    *ngIf="selected.isDraft() && !(selected.isSingleGroup() || selected.isEditing(scoreGroup) || selected.isEditing())"
                    class="text-button edit-button" tabindex="-1" title="Edit"
                    (click)="$event.stopPropagation(); selected.edit(scoreGroup)">
                    <img src="assets/edit-no-whitespace.svg" class="icon" />
                  </button>
                  <div class="title-buttons">
                    <button mat-button class="text-button button"
                      (click)="toggleCollapsed(scoreGroup, 'scoreGroups[' + i + ']')">
                      <img src="assets/content-icon/ic-16.svg" class="icon arrow" />
                    </button>
                  </div>
                </div>
                <span *ngIf="!selected.isSingleGroup()"
                  class="error-message">{{scoreGroup.rangesStatusField.getDisplayedIssue()}}</span>
                <div class="input-container" *ngVar="scoreGroup.name as field"
                  [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !scoreGroup.isNew() && field.isDirty(), hidden: selected.isSingleGroup()}">
                  <div class="label-line">
                    <span class="label">Name</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The name of the group.', 'Breathing Qualtiy')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input type="text" maxlength="20" class="input" placeholder="Breathing Quality" (blur)="field.touch()"
                    [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <div class="input-container" [ngClass]="{double: selected.isSingleGroup()}"
                  [title]="scoreGroup.maxScoreDependency.getSum()">
                  <div class="label-line">
                    <span class="label">Maximum Scale Value</span>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The maximum possible scale value for this group given the trackable scales and question answers that contribute to it.')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input type="text" class="input" [ngModel]="scoreGroup.maxScoreDependency.getSum()" disabled />
                </div>
                <div class="double">
                  <div class="subheader-line" *ngVar="scoreGroup.scaleRangesGroup as group"
                    [ngClass]="{dirty: group.isDirty() && !scoreGroup.isNew(), error: group.hasVisibleIssue()}">
                    <div class="subheader-text">
                      <span class="subheader">Scale Ranges</span>
                      <div class="dot"></div>
                      <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                        (click)="showFieldInfo($event, 'The set of disjoint scale ranges that will determine the score for this group.')">
                        <img src="assets/ic_information_blk.svg" class="icon" />
                      </button>
                    </div>
                    <button mat-button class="text-button subheader-button custom-size custom-color"
                      *ngIf="selected.isDraft()" (click)="openPieceManager('SUMMARY_SCALE', scoreGroup)">
                      Choose scale from templates
                    </button>
                    <button mat-button class="text-button subheader-button custom-size custom-color"
                      *ngIf="selected.isDraft()" (click)="scoreGroup.addScaleRange(); setShouldScrollToNew()">
                      Add new scale range
                    </button>
                  </div>
                  <div *ngIf="scoreGroup.scaleRanges.length == 0" class="empty-state"
                    [ngClass]="{error: scoreGroup.rangesStatusField.getDisplayedIssue()}">
                    {{scoreGroup.rangesStatusField.getDisplayedIssue() || ''}}
                  </div>
                  <div (ngInit)="scrollToNew($event)" class="card input-area"
                    *ngFor="let range of scoreGroup.scaleRanges; index as i"
                    [ngClass]="{dirty: range.isDirty() || (scoreGroup.isDirty() && range.isNew), invalid: range.hasVisibleIssue()}">
                    <button mat-button class="text-button corner-button" [disabled]="!selected.isDraft()"
                      (click)="scoreGroup.removeScaleRange(range.id); scoreGroup.rangesStatusField.touch();">
                      <img src="assets/content-icon/ic-05.svg" class="icon" />
                    </button>
                    <span class="error-message">{{range.statusField.getDisplayedIssue()}}</span>
                    <div class="input-container" *ngVar="translateRangeIndex(i) as rangeId" [title]="rangeId">
                      <div class="label-line">
                        <span class="label">Range ID</span>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'An identifier for the scale range that is unique among scale ranges within the group.')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input type="text" class="input" [ngModel]="rangeId" disabled />
                    </div>
                    <div class="input-container" *ngVar="range.name as field"
                      [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                      [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                      <div class="label-line">
                        <span class="label">Text</span>
                        <div class="dirty-dot"></div>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'The text that will show up as the score for this group.', 'Good')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input type="text" maxlength="20" class="input" placeholder="Good" (blur)="field.touch()"
                        [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
                      <span class="error-message">{{field.getDisplayedIssue()}}</span>
                    </div>
                    <div class="input-container" *ngVar="range.minimum as field"
                      [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                      [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                      <div class="label-line">
                        <span class="label">Minimum</span>
                        <div class="dirty-dot"></div>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'The inclusive minimum group scale value over some interval required for the scale range to be applied.', '1')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="1"
                        (blur)="range.touchMinMax(field)" [(ngModel)]="field.value"
                        [disabled]="!(selected.isDraft() && field.isEditable())" />
                      <span class="error-message">{{field.getDisplayedIssue()}}</span>
                    </div>
                    <div class="input-container" *ngVar="range.maximum as field"
                      [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                      [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                      <div class="label-line">
                        <span class="label">Maximum</span>
                        <div class="dirty-dot"></div>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'The inclusive maximum group scale value over some interval required for the scale range to be applied.', '10')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="10"
                        (blur)="range.touchMinMax(field)" [(ngModel)]="field.value"
                        [disabled]="!(selected.isDraft() && field.isEditable())" />
                      <span class="error-message">{{field.getDisplayedIssue()}}</span>
                    </div>
                  </div>
                </div>
                <div class="card-bottom-buttons double">
                  <button mat-button *ngIf="scoreGroup.scaleRanges.length > 0" class="button text-button custom-size"
                    (click)="addSummaryScalePiece(scoreGroup.scaleRanges)">
                    Save scale as template
                  </button>
                  <button mat-button *ngIf="!selected.isSingleGroup() && selected.canAddRemoveScaleRanges()"
                    class="button text-button custom-size custom-color warn" [disabled]="!selected.isDraft()"
                    (click)="removeScoreGroup(selected, i); selected.scoreGroupStatusField.touch();">
                    Remove score group
                  </button>
                  <button mat-button *ngIf="selected.isSingleGroup() && selected.canAddRemoveScaleRanges()"
                    class="button text-button custom-size" [disabled]="!selected.isDraft()"
                    (click)="addScoreGroup(selected)">
                    Add score group
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="selected.scoreGroups.length > 1" class="input-container double"
              [title]="selected.maxScoreDependency.getSum()">
              <div class="label-line">
                <span class="label">Maximum Summary Scale Value</span>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The maximum possible summary scale value given the group scales scales.')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" [ngModel]="selected.maxScoreDependency.getSum()" disabled />
            </div>
            <div *ngIf="selected.scoreGroups.length > 1" class="double">
              <div class="subheader-line" *ngVar="selected.scaleRangesGroup as group"
                [ngClass]="{dirty: group.isDirty() && !selected.isNew(), error: group.hasVisibleIssue()}">
                <div class="subheader-text">
                  <span class="subheader">Summary Scale Ranges</span>
                  <div class="dot"></div>
                  <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                    (click)="showFieldInfo($event, 'The scale ranges that will be used to determine the compass\'s score text over some interval.  Each range provides conditions under which it will apply.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <button mat-button class="text-button subheader-button custom-size custom-color"
                  *ngIf="selected.isDraft() && selected.canAddRemoveScaleRanges()"
                  (click)="openPieceManager('SUMMARY_SCALE', selected)">
                  Choose scale from templates
                </button>
                <button mat-button *ngIf="selected.isDraft() && selected.canAddRemoveScaleRanges()"
                  class="text-button subheader-button custom-size custom-color"
                  (click)="selected.addScaleRange(); setShouldScrollToNew()">
                  Add new scale range
                </button>
              </div>
              <div *ngIf="selected.scaleRanges.length == 0" class="empty-state"
                [ngClass]="{error: selected.rangesStatusField.getDisplayedIssue()}">
                {{selected.rangesStatusField.getDisplayedIssue() || ''}}
              </div>
              <div (ngInit)="scrollToNew($event)" class="card input-area"
                *ngFor="let range of selected.scaleRanges; index as i"
                [ngClass]="{minimal: !selected.isEditing(), dirty: range.isDirty() || (selected.isDirty() && range.isNew), invalid: range.hasVisibleIssue()}">
                <button mat-button *ngIf="selected.canAddRemoveScaleRanges()" class="text-button corner-button"
                  [disabled]="!selected.isDraft()"
                  (click)="selected.removeScaleRange(range.id); selected.rangesStatusField.touch();">
                  <img src="assets/content-icon/ic-05.svg" class="icon" />
                </button>
                <span class="error-message">{{range.statusField.getDisplayedIssue()}}</span>
                <div class="input-container" *ngVar="translateRangeIndex(i) as rangeId" [title]="rangeId">
                  <div class="label-line">
                    <span class="label">Range ID</span>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'An identifier for the scale range that is unique among summary scale ranges within the compass.')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input type="text" class="input" [ngModel]="rangeId" disabled />
                </div>
                <div class="input-container" *ngVar="range.name as field"
                  [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Text</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The text that will show up in the compass\'s score card if the scale range\'s conditions are met.', 'Good')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input type="text" maxlength="20" class="input" placeholder="Good" (blur)="field.touch()"
                    [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <div class="input-container" *ngVar="range.minimum as field"
                  [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Minimum</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The inclusive minimum summary scale value over some interval required for the scale range to be applied.', '1')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="1"
                    (blur)="range.touchMinMax(field)" [(ngModel)]="field.value"
                    [disabled]="!(selected.isDraft() && field.isEditable())" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <div class="input-container" *ngVar="range.maximum as field"
                  [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Maximum</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The inclusive maximum summary scale value over some interval required for the scale range to be applied.', '10')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="10"
                    (blur)="range.touchMinMax(field)" [(ngModel)]="field.value"
                    [disabled]="!(selected.isDraft() && field.isEditable())" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
              </div>
            </div>
            <!-- <div class="card-bottom-buttons double">
              <button mat-button *ngIf="selected.scaleRanges.length > 0" class="button text-button custom-size"
                (click)="addSummaryScalePiece(selected.scaleRanges)">
                Save scale as template
              </button>
            </div> -->
          </div>
        </div>
        <div *ngIf="selected.groupIndex == 4" class="fields">
          <div (ngInit)="scrollToNew($event)" [collapsible]="'documents[' + i + ']'" [ecController]="ecController"
          class="input-area card has-title no-overflow" *ngFor="let document of selected.documents; index as i"
          [ngClass]="{minimal: !(selected.isEditing(document) || selected.isEditing()),
            dirty: document.isDirty() || (selected.isDirty() && document.isNew), invalid: document.hasVisibleIssue()}">
          <div class="double card-title">
            <span class="title clickable" (click)="toggleCollapsed(document, 'documents[' + i + ']')">
              <span class="number">{{i + 1}}:</span>{{(document.name?.value || '').trim() || 'Document'}}
            </span>
            <div class="dot"></div>
            <button mat-button *ngIf="selected.isDraft() && !(selected.isEditing(document) || selected.isEditing())"
              class="text-button edit-button" tabindex="-1" title="Edit"
              (click)="$event.stopPropagation(); selected.edit(document)">
              <img src="assets/edit-no-whitespace.svg" class="icon" />
            </button>
            <div class="title-buttons">
              <button mat-button class="text-button button"
                (click)="toggleCollapsed(document, 'documents[' + i + ']')">
                <img src="assets/content-icon/ic-16.svg" class="icon arrow" />
              </button>
            </div>
          </div>
          <div class="input-container double" *ngVar="document.name as field"
          [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
          [ngClass]="{error: field.getDisplayedIssue(), dirty: !document.isNew && field.isDirty()}">
            <div class="label-line">
              <span class="label">Document Name</span>
              <div class="dirty-dot"></div>
              <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                (click)="showFieldInfo($event, 'The name of the document.', 'The Grapes of Wrath')">
                <img src="assets/ic_information_blk.svg" class="icon" />
              </button>
            </div>
            <input type="text" class="input" maxlength="512" placeholder="The Grapes of Wrath"
            (blur)="field.touchOrOption($event)" 
            [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())"
            (closed)="field.touch()" />
            <span class="error-message">{{field.getDisplayedIssue()}}</span>
          </div>
          <div class="input-container double" *ngVar="document.url as field"
          [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
          [ngClass]="{error: field.getDisplayedIssue(), dirty: !document.isNew && field.isDirty()}">
            <div class="label-line">
              <span class="label">Link to the document</span>
              <div class="dirty-dot"></div>
              <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                (click)="showFieldInfo($event, 'The url of the document.', 'https://www.huddyhealth.com')">
                <img src="assets/ic_information_blk.svg" class="icon" />
              </button>
            </div>
            <input type="text" class="input" maxlength="1024" placeholder="https://www.huddyhealth.com"
              (blur)="field.touchOrOption($event)" 
              [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())"
              (closed)="field.touch()" />
            <span class="error-message">{{field.getDisplayedIssue()}}</span>
          </div>
          <div class="input-container double" *ngVar="document.authors as field"
          [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
          [ngClass]="{error: field.getDisplayedIssue(), dirty: !document.isNew && field.isDirty()}">
            <div class="label-line">
              <span class="label">Document Authors</span>
              <div class="dirty-dot"></div>
              <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                (click)="showFieldInfo($event, 'The authors of the document.', 'John Steinbeck')">
                <img src="assets/ic_information_blk.svg" class="icon" />
              </button>
            </div>
            <input type="text" class="input" maxlength="255" placeholder="John Steinbeck"
              (blur)="field.touchOrOption($event)" 
              [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())"
              (closed)="field.touch()" />
            <span class="error-message">{{field.getDisplayedIssue()}}</span>
          </div>
          <div class="input-container  double" *ngVar="document.description as field"
          [title]="(selected.isDraft() && field.isEditable()) ? '' : (field.value != null ? field.value : '')"
          [ngClass]="{error: field.getDisplayedIssue(), dirty: !document.isNew && field.isDirty()}">
            <div class="label-line">
              <span class="label">Document Description</span>
              <div class="dirty-dot"></div>
              <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                (click)="showFieldInfo($event, 'A description of the document.', 'A book about the 1930s')">
                <img src="assets/ic_information_blk.svg" class="icon" />
              </button>
            </div>
            <div class="input-inner-container">
              <label for="name" class="hitbox text"></label>
              <textarea textareaAutoheight id="name" class="input" placeholder="A book about the 1930s" (blur)="field.touch()"
                [(ngModel)]="field.value" [disabled]="!(selected.isDraft() && field.isEditable())"></textarea>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
          </div>
          <div class="card-bottom-buttons double">
            <button mat-button class="button text-button custom-size custom-color warn"
              [disabled]="!selected.isDraft()"
              (click)="removeDocument(selected, i); selected.documentsStatusField.touch();">
              Remove document
            </button>
          </div>
        </div>        
      </div>
         
      </div>
      <div class="buttons">
        <mat-progress-spinner *ngIf="selected.isSaving()" class="spinner" color="primary" mode="indeterminate"
          diameter="21">
        </mat-progress-spinner>
        <div *ngIf="selected.isDraft() && (selected.isEditing(null) || selected.isNew())">
          <button mat-button class="text-button secondary shy" [disabled]="!selected.discardEnabled()"
            (click)="discardChanges(selected)">Discard changes</button>
          <button mat-button *ngIf="selected.groupIndex == 1 && selected.canAddTrackables()"
            class="text-button secondary" (click)="addTrackable(selected)">+ Add trackable</button>
          <button mat-button *ngIf="selected.groupIndex == 4"
            class="text-button secondary" (click)="addDocument(selected)">+ Add document</button>
          <button mat-button *ngIf="selected.groupIndex == 2" class="text-button secondary"
            (click)="previewAssessment(selected)">Preview assessment</button>
          <button mat-button class="text-button secondary" [disabled]="!selected.deleteEnabled()"
            (click)="selected.delete()">Delete</button>
          <button mat-button *ngIf="otherMap.has(selected.id)" class="text-button secondary"
            (click)="seePublished(selected)">See published</button>
          <button mat-button *ngIf="!selected.isNew()" class="text-button secondary"
            [disabled]="!selected.canPublish()" (click)="selected.publish()">Publish</button>
          <button mat-button *ngIf="!selected.isNew()" class="text-button secondary"
            (click)="selected.edit(selected)">Edit</button>
          <button mat-button *ngIf="selected.isNew() && selected.maxGroup != null && selected.maxGroup < 4"
            class="text-button secondary" (click)="selected.goNext()">Next</button>
          <button mat-button class="text-button" [disabled]="!selected.compassSaveEnabled()"
            (click)="selected.save()">Save</button>
        </div>
        <div *ngIf="!(selected.isEditing(null) || selected.isNew())">
          <button mat-button *ngIf="selected.groupIndex == 2 && selected.answerables?.length > 0"
            class="text-button secondary" (click)="previewAssessment(selected)">Preview assessment</button>
          <button mat-button *ngIf="selected.groupIndex == 1 && selected.canAddTrackables()"
            class="text-button secondary" (click)="addTrackable(selected)">+ Add trackable</button>
          <button mat-button class="text-button" (click)="selected.edit(null)">Done</button>
        </div>
        <div *ngIf="!selected.isDraft()">
          <button mat-button *ngIf="!selected.isPrivate()" class="text-button secondary"
            (click)="selected.updateSettings()">Settings</button>
          <button mat-button *ngIf="!selected.isDraft()" class="text-button"
            (click)="editDraft(selected)">{{otherMap.has(selected.id) ? 'Edit' : 'Create'}} draft</button>
        </div>
      </div>
    </div>      
      <div class="backdrop" [ngClass]="{showing: infoPopoverShowing}" (click)="hideInfoPopover()"></div>
      <div #popover class="popover fixed-arrow" [ngClass]="{showing: infoPopoverShowing}"
        [style]="getInfoPopoverPosition()">
        <div class="popover-content">
          <div class="header">Header</div>
          <div class="subheader">Subheader 1</div>
          <div class="text">Text 1</div>
          <div class="subheader">Subheader 2</div>
          <div class="text">Text 2</div>
          <div class="subheader">Subheader 3</div>
          <div class="text">Tex 3</div>
        </div>
      </div>
    </div>
    <div class="backdrop" [ngClass]="{showing: fieldInfoShowing}" (click)="hideFieldInfo()">
      <div #fieldInfo class="popover" [ngClass]="{showing: fieldInfoShowing}" [style]="fieldInfoPosition"
        (click)="$event.stopPropagation()">
        <div class="popover-content">
          <div class="text"></div>
          <div class="subheader">Example</div>
          <div class="text"></div>
        </div>
      </div>
      <div class="popover-arrow" [ngClass]="{showing: fieldInfoShowing}" [style]="fieldInfoArrowPosition"></div>
    </div>
  </div>

